import moment from '@/utils/moment'

/**
 * 判断是否在时间区间内
 * @startTime: 开始时间
 * @endTime: 结束时间
*/
export function TimeInDate(startTime, endTime) {
  if (!endTime) {
    endTime = moment()
  }
  if (moment(startTime).diff(moment()) < 0 && moment(endTime).diff(moment()) > 0) {
    return true
  }
  return false
}

/**
 * 时间转换方法
 * @Date: 2023-09-23 16:54:38
 * @LastEditors: 柴树达 w__apple@163.com
 * @param {*} time 时间戳
 * @param {*} format 格式
 */
export function timeFormat(time, format = 'yyyy-MM-DD HH:mm') {
  return moment(time).format(format)
}

/**
 * 将数字转成中文大写
 * @params num
 */
export function toChinesNum(num) {
  var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']// 可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return '零'
  }
  var english = num.toString().split('')
  var result = ''
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i// 倒序排列设值
    result = arr2[i] + result
    var arr1_index = english[des_i]
    result = arr1[arr1_index] + result
  }
  // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十')
  // 合并中间多个零为一个零
  result = result.replace(/零+/g, '零')
  // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万')
  // 将【亿万】换成【亿】
  result = result.replace(/亿万/g, '亿')
  // 移除末尾的零
  result = result.replace(/零+$/, '')
  // 将【零一十】换成【零十】
  // result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, '十')
  return result
}

export function weekDayToChina(dayNum) {
  const weeks = {
    0: '星期日',
    1: '星期一',
    2: '星期二',
    3: '星期三',
    4: '星期四',
    5: '星期五',
    6: '星期六'
  }
  return weeks[+dayNum]
}

// const BASE_URL = process.env.VUE_APP_HOST_URL
const BASE_URL = process.env.VUE_APP_FILE_URL

/* 拼接链接域名 */
export function returnFullPath(url, duplicateRemove = false) {
  if (!url) {
    return ''
  }
  if (url.includes('http')) {
    return url
  }
  if (duplicateRemove) {
    return BASE_URL + url
  }

  // const formatURL = url.replace(/\/uploads/gi, '')
  return BASE_URL + url
}

export function downloadFile(url, name) {
  var x = new XMLHttpRequest()
  x.open('GET', url, true)
  x.responseType = 'blob'
  x.onload = () => {
    var url = window.URL.createObjectURL(x.response)
    var a = document.createElement('a')
    a.href = url
    a.download = name // 下载后的文件名
    a.click()
  }
  x.send()
  // this.$message.success('下载成功!')
}

/* 更换ico图标 */
export const changeFavicon = link => {
  let $favicon = document.querySelector('link[rel="icon"]')
  if ($favicon !== null) {
    $favicon.href = link
  } else {
    $favicon = document.createElement('link')
    $favicon.rel = 'icon'
    $favicon.href = link
    document.head.appendChild($favicon)
  }
}

// 深拷贝对象
export function deepClone(obj) {
  const _toString = Object.prototype.toString

  // null, undefined, non-object, function
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  // DOM Node
  if (obj.nodeType && 'cloneNode' in obj) {
    return obj.cloneNode(true)
  }

  // Date
  if (_toString.call(obj) === '[object Date]') {
    return new Date(obj.getTime())
  }

  // RegExp
  if (_toString.call(obj) === '[object RegExp]') {
    const flags = []
    if (obj.global) {
      flags.push('g')
    }
    if (obj.multiline) {
      flags.push('m')
    }
    if (obj.ignoreCase) {
      flags.push('i')
    }

    return new RegExp(obj.source, flags.join(''))
  }

  const result = Array.isArray(obj) ? [] : obj.constructor ? new obj.constructor() : {}

  for (const key in obj) {
    result[key] = deepClone(obj[key])
  }

  return result
}

// 判断对象是否为空
export const isEmpty = obj => Reflect.ownKeys(obj).length === 0 && obj.constructor === Object

// 处理富文本数据
export function formatRichText(html) {
  let newContent = html.replace(/<img[^>]*>/gi,
    (match) => {
      match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
      match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
      match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
      return match
    })
  newContent = newContent.replace(/style="[^"]+"/gi,
    (match) => {
      match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
        'max-width:100%;')
      return match
    })
  newContent = newContent.replace(/<br[^>]*\/>/gi, '')

  newContent = newContent.replace(/<img/gi,
    '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"')
  return newContent
}
export function getUrlParam(url, paramName) {
  // 查找查询字符串的起始位置
  const queryIndex = url.indexOf('?')
  // 如果没有查询字符串，直接返回 null
  if (queryIndex === -1) {
    return null
  }
  // 提取查询字符串部分
  const queryString = url.slice(queryIndex + 1)
  // 创建 URLSearchParams 实例
  const params = new URLSearchParams(queryString)
  // 获取指定参数的值
  return params.get(paramName)
}

export function getSchoolMark() {
  const matchArr = window.location.pathname.match(/student\/(\w+)/)
  let dean_type = ''
  if (matchArr) {
    dean_type = matchArr[1]
  } else {
    dean_type = getUrlParam(window.location.href, 'dean_type') || 'd1ba'
  }

  return dean_type
}
